<template>
  <el-dialog
    class="rc-dialog"
    :title="titleName"
    :visible.sync="showAsyncModal.flag"
    width="700px"
    top="30vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    destroy-on-close
    @close="closeDialog"
  >
    <div class="title_msg">同步浙江网络学院配置到以下学院：</div>
    <div class="main-content">
      <el-transfer
        filterable
        :filter-method="filterMethod"
        filter-placeholder="请输入组织名称"
        v-model="value"
        :data="data"
        :props="{
          key: 'uuid',
          label: 'deptName',
        }"
        :titles="['组织名称', '已选组织']"
      >
      </el-transfer>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" size="small">取 消</el-button>
      <el-button type="primary" size="small" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { collegeSimpleListFeign } from "@/api/user";
import { pushCollege } from "@/api/resourceService";
export default {
  data() {
    return {
      data: [],
      value: [],
      titleName: "同步其他学院",
      filterMethod(query, item) {
        return item.deptName.indexOf(query) > -1;
      },
    };
  },
  props: {
    showAsyncModal: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  created() {
    collegeSimpleListFeign().then((res) => {
      if (!res || res.code != 0) return;
      this.data = res.data;
    });
  },
  updated() {
    let doms = document.getElementsByClassName("el-checkbox__label");
    for (let i = 0; i < doms.length; i++) {
      const dom = doms[i];
      dom.title = dom.innerText;
    }
  },
  methods: {
    submit() {
      const _this = this;
      if (this.value.length === 0) {
        this.$message({
          message: "请选择要同步的学院",
          type: "warning",
        });
      } else {
        this.$confirm(`确认同步浙江网络学院设置到选中学院吗？`, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let deptList = [];
          for (let i = 0; i < _this.value.length; i++) {
            let item = _this.data.filter(function (ele) {
              return ele.uuid == _this.value[i];
            });
            deptList.push({ uuid: item[0].uuid, deptLevelCode: item[0].deptLevelCode });
          }
          pushCollege(deptList).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("closeDialog");
          });
        });
      }
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
    clearDept() {
      this.value = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  .title_msg {
    margin-left: 36px;
    margin-bottom: 12px;
  }
  .main-content {
    max-height: 360px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
/deep/.el-transfer-panel__item.el-checkbox .el-checkbox__label {
  width: 222px;
}
</style>
